export class QuoteCoverages {
    formStatus = 'notstarted';
    
    policyEffectiveDate: Date;
    expiringYearGPC: number;
    estimatedAnnualGPC: number;
    
    mediaCommercial: string;
    mediaDocumentary: string;
    mediaEducational: string;
    mediaIndustrial: string;
    mediaPodcast: string;
    mediaWebisodes: string;

    glOccurrenceAggregateLimitOneMil: string;
    glOccurrenceAggregateLimitTwoMil: string;
    
    medicalExpenseLimit1000: string;
    medicalExpenseLimit5000: string;

    blanketWaiverofSubrogationYes: string;
    blanketWaiverofSubrogationNo: string;

    blanketAdditionalInsuredsYes: string;
    blanketAdditionalInsuredsNo: string;

    dicePropsSetsWardrobe: number;
    diceExtraExpenses: number;
    diceThirdPartyProperty: number;
    diceNMiscellaneousEquipment: number;
    diceNegativeFilm: number;
    diceFaultyStock: number;
    diceAdditionalCoverages: string;

    hiredorBorrowedDamageYes: string;
    hiredorBorrowedDamageNo: string;

    estimatedCostOfHire: number;
    numberOfEmployees: number;

    autoNoOfEmployess: number;

    umbrellaLimit: number;

    workersCopensation = [
        {
            stateOfHire: '',
            classCode: '',
            otherClassCode: '',
            payrollAmount: '',
            partTimeEmp: '',
            fullTimeEmp: ''
        }
    ];


    fileAttachments = [
        {
            fileName: '',
            filetype: ''
        }
    ];
}
